import { styled } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { TextV2 } from '@insights-ltd/design-library/components';

const StyledDiv = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  height: '100vh',
});

const FullScreenError = ({ message }: { message: string }) => {
  const { t } = useTranslation();

  return (
    <StyledDiv>
      <TextV2 component="h1" variant="bodyBold">
        {t('ui.event-management.error')}
      </TextV2>
      <TextV2 component="p">{message}</TextV2>
    </StyledDiv>
  );
};

export default FullScreenError;
